import { z, ZodType } from 'zod';

export const actionVerbSchema = z.literal('read'); // TODO : à compléter
export type ActionVerb = z.infer<typeof actionVerbSchema>;

/**
 * @deprecated
 */
export const socialActionStructSchema_deprecated = z.object({
    action: z.string(),
    do: z.string(),
    type: z.string(),
    targetId: z.number(),
    targetType: z.string(),
});
/**
 * @deprecated
 */
export type SocialActionStructDeprecated = z.infer<typeof socialActionStructSchema_deprecated>;

/**
 * @deprecated
 */
export const socialActionSchema_deprecated = z.object({
    type: z.string(),
    class: z.string(),
    isActive: z.boolean(),
    label: z.string(),
    cssClass: z.string(),
    cssColor: z.string(),
    struct: socialActionStructSchema_deprecated,
    stats: z
        .object({
            total: z.number(),
        })
        .optional(),
});

/**
 * @deprecated
 */
export type SocialActionDeprecated = z.infer<typeof socialActionSchema_deprecated>;

export const socialActionSchema = z.object({
    targetId: z.number(),
    targetType: z.string(),
    type: z.string(),
    icon: z.string().nullable(),
    isActive: z.boolean().optional(),
    count: z.number().optional(),
    label: z.string(),
});
export type SocialAction = z.infer<typeof socialActionSchema>;

export const actionParamsSchema = z.object({
    targetId: z.number(),
    targetType: z.string(),
    type: z.string(),
});
export type ActionParams = z.infer<typeof actionParamsSchema>;

export const inferActionUpdateParamsSchema = <T extends ZodType>(type: T) => {
    return actionParamsSchema.extend({
        value: type,
    });
};
export type ActionUpdateParamsSchema<T> = z.infer<ReturnType<typeof inferActionUpdateParamsSchema<ZodType<T>>>>;
